import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AdminLayout from "../../components/layout/AdminLayout";

import { Helmet } from "react-helmet-async";

import AdminRegistrationContext from "../../context/adminRegistration/adminRegistrationContext";

import LoadingSpinner from "../../components/utilities/LoadingSpinner";
import RegistrationForm from "../../components/registrationAdmin/RegistrationForm";
import RegistrationFormEdit from "../../components/registrationAdmin/RegistrationFormEdit";

const RegistrationFormPage = () => {
  const { id } = useParams();
  const adminRegistrationContext = useContext(AdminRegistrationContext);
  const {
    getRegistration,
    registration,
    clearRegistration,
    clearStudentMatchResults,
  } = adminRegistrationContext;
  const [showFormEdit, setShowFormEdit] = useState(false);

  useEffect(() => {
    getRegistration(id);
    return () => {
      clearRegistration();
      clearStudentMatchResults();
    };
  }, []);
  return (
    <AdminLayout>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Enrollment Registration Form</title>
      </Helmet>
      <div id="interest-form-page">
        <div className="container">
          {Object.keys(registration).length !== 0 ? (
            showFormEdit ? (
              <RegistrationFormEdit
                formData={registration}
                setShowFormEdit={setShowFormEdit}
              />
            ) : (
              <RegistrationForm
                formData={registration}
                setShowFormEdit={setShowFormEdit}
              />
            )
          ) : (
            <LoadingSpinner />
          )}
        </div>
      </div>
    </AdminLayout>
  );
};

export default RegistrationFormPage;
